// extracted by mini-css-extract-plugin
export var anticlockwise = "cz_l2";
export var svg = "cz_l0";
export var wrapper = "cz_B";
export var wrapperFlexCenter = "cz_l1";